import { apiClient } from "../apiClient";
import { IStrIdsRequest } from "../../model/request/IStrIdsRequest";
import { IIdsRequest } from "../../model/request/IIdsRequest";

const DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_API = "dot-xet-hoc-vu-pham-vi-sinh-vien";
export const dotXetHocVuPhamViSinhVienApi = {
    SelectByHocKyNamHoc: (hoc_ky: number, nam_hoc: string) => apiClient.get(`${DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_API}/hoc-ky/${hoc_ky}/nam-hoc/${nam_hoc}`),
    Inserts: (id_dot_xet: number, request: IStrIdsRequest) => apiClient.post(`${DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_API}/dot-xet/${id_dot_xet}`, request),
    Deletes: (request: IIdsRequest) => apiClient.post(`${DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_API}/deletes`, request),
}